import _objectSpread from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import React from 'react';
import { readConfObject } from '@jbrowse/core/configuration';
import { observer } from 'mobx-react';
import { useTheme } from '@mui/material';
// locals
import Arrow from './Arrow';
function Segments(props) {
  var feature = props.feature,
    featureLayout = props.featureLayout,
    selected = props.selected,
    config = props.config,
    _props$subfeatures = props.subfeatures,
    subfeatures = _props$subfeatures === void 0 ? feature.get('subfeatures') : _props$subfeatures;
  var theme = useTheme();
  var c = readConfObject(config, 'color2', {
    feature: feature
  });
  var color2 = c === '#f0f' ? theme.palette.text.secondary : c;
  var _featureLayout$absolu = featureLayout.absolute,
    _featureLayout$absolu2 = _featureLayout$absolu.left,
    left = _featureLayout$absolu2 === void 0 ? 0 : _featureLayout$absolu2,
    _featureLayout$absolu3 = _featureLayout$absolu.top,
    top = _featureLayout$absolu3 === void 0 ? 0 : _featureLayout$absolu3,
    _featureLayout$absolu4 = _featureLayout$absolu.width,
    width = _featureLayout$absolu4 === void 0 ? 0 : _featureLayout$absolu4,
    _featureLayout$absolu5 = _featureLayout$absolu.height,
    height = _featureLayout$absolu5 === void 0 ? 0 : _featureLayout$absolu5;
  var y = top + height / 2;
  return React.createElement(React.Fragment, null, React.createElement("line", {
    "data-testid": feature.id(),
    x1: left,
    y1: y,
    y2: y,
    x2: left + width,
    stroke: color2
  }), subfeatures === null || subfeatures === void 0 ? void 0 : subfeatures.map(function (subfeature) {
    var subfeatureId = String(subfeature.id());
    var subfeatureLayout = featureLayout.getSubRecord(subfeatureId);
    // This subfeature got filtered out
    if (!subfeatureLayout) {
      return null;
    }
    var _ref = subfeatureLayout.data || {},
      GlyphComponent = _ref.GlyphComponent;
    return React.createElement(GlyphComponent, _objectSpread({
      key: "glyph-".concat(subfeatureId)
    }, props, {
      feature: subfeature,
      topLevel: false,
      featureLayout: subfeatureLayout,
      selected: selected
    }));
  }), React.createElement(Arrow, _objectSpread({}, props)));
}
export default observer(Segments);